import React from 'react'
import {NavLink} from 'react-router-dom'
import {useWindowSize} from '@therms/react-modules'
import classnames from 'classnames'

interface MenuLinkProps {
  children?: React.ReactNode
  className?: string
  to: string
}

function MenuLink({children, className, to}: MenuLinkProps) {
  const {height} = useWindowSize()

  return (
    <NavLink
      activeClassName="bg-surface-subtle text-color-strong"
      to={to}
      className={classnames(
        `px-sm text-color-subtle hover:bg-surface-strong group flex rounded-md text-sm font-medium transition`,
        {
          'py-xs': height >= 750,
          'py-xxs': height < 750,
        },
        className,
      )}
    >
      {children}
    </NavLink>
  )
}

export {MenuLink}
